const TRANSLATIONS = "translations";
const isTranslationDictionaryNotEmpty = (dictionary) =>
  !!Object.keys(dictionary[TRANSLATIONS]).length;
const chooseActiveDictionary = (...dictionaryJsonList) => {
  for (let i = 0; i < dictionaryJsonList.length; i++) {
    const dictionary = JSON.parse(dictionaryJsonList[i]);
    if (isTranslationDictionaryNotEmpty(dictionary)) {
      return dictionary;
    }
  }
};

/**
 * defines Translation Dictionary to use
 * @param context provides access to 3 validation JSONs from en.json:
 * validation_messages, validation_fallback_messages and default_messages
 * @returns {Object}
 */
export const createTranslationDictionary = (context) => {
  const {
    validationDictionaryJSON,
    validationFallbackDictionaryJSON,
    validationDefaultDictionaryJSON,
  } = context;
  const activeDictionary = chooseActiveDictionary(
    validationDictionaryJSON,
    validationFallbackDictionaryJSON,
    validationDefaultDictionaryJSON
  );
  const localizations = Object.values(activeDictionary[TRANSLATIONS]);
  const translationKeys = Object.keys(activeDictionary[TRANSLATIONS]).map(
    (key) => key.split(".").pop()
  );

  return translationKeys.reduce((acc, key, i) => {
    acc[key] = localizations[i];
    return acc;
  }, {});
};

/**
 * Replace translation placeholders in a text with corresponding values in case you have to set translations using javascript
 * @param {*} text
 * @param {*} placeholders dict of placeholder keys and their values
 * @returns
 */
export const replaceTranslationPlaceholders = (text, placeholders) => {
  let modifiedText = text;
  Object.keys(placeholders).forEach((key) => {
    const regex = new RegExp(`{${key}}`, "g");
    modifiedText = modifiedText.replace(regex, placeholders[key]);
  });
  return modifiedText;
};

/**
 * Localises a decimal number to currency format as per channel locale and currency.
 * @param {*} value Value to localise
 * @param {*} formatWithoutDecimals Whether include fraction digits or not
 * @returns Localised currency string
 */
export const localiseCurrency = (value, formatWithoutDecimals = false) => {
  const currency = window.channelCurrency;
  if (!currency) {
    return console.warn("channelCurrency is not defined");
  }
  const locale = window.channelLocale || "en-GB";
  return Intl.NumberFormat(locale, {
    style: "currency",
    currencyDisplay: "narrowSymbol",
    currency,
    ...(formatWithoutDecimals && {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
  }).format(value);
};

/**
 * Localises a number to a percentage format as per channel locale
 * @param {*} value Value of percentage to localise
 * @returns Localised percentage string
 */
export const localisePercentage = (value) => {
  const locale = window.channelLocale || "en-GB";
  return Intl.NumberFormat(locale, {
    style: "percent",
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value / 100);
};
